export { default } from "./MasteryDetail";

